import { IAppState } from '../../../AppModulesWrapper';

/**
 * @description Проверяет, выбрана ли категория "Продажа квартиры в ЖК".
 */
export function selectIsJKCategory(state: IAppState): boolean {
  return state.servicePickerWidget.offer.category === 'newBuildingFlatSale';
}
